import { render } from "./QuizLayout.vue?vue&type=template&id=50843d1f"
import script from "./QuizLayout.vue?vue&type=script&lang=js"
export * from "./QuizLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__